import * as React from 'react';
import { ItemInfoLabel } from 'components';
require('./style.css');

interface IProps {
	text: string;
	data: string;
}

export const ItemInfoLabelWithData = (props: IProps) => {
	return (
		<ItemInfoLabel text={props.text}>
			<div className="strong">{props.data}</div>
		</ItemInfoLabel>
	);
};
